import { CITY } from "../types";

export const cities1: CITY[] = [
  {
    id: 1,
    name: "ADANA",
    voterCountTotal: 1526827,
    votesCountTotal: 1313497,
    votesCountValid: 1289267,
    votesCountInvalid: 24230,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 440540 },
      { partyId: 2, partyName: "MHP", vote: 153060 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6992 },
      { partyId: 4, partyName: "VATAN", vote: 2395 },
      { partyId: 5, partyName: "HDP", vote: 172831 },
      { partyId: 6, partyName: "CHP", vote: 339339 },
      { partyId: 7, partyName: "SP", vote: 13816 },
      { partyId: 8, partyName: "İYİP", vote: 159881 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 279 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 134 },
    ],
    // bagimsiz_toplam_oy: 413,
    union1Vote: 11404,
    union2Vote: 2779,
    parliamentarianCount: 15,
  },
  {
    id: 2,
    name: "ADIYAMAN",
    voterCountTotal: 399766,
    votesCountTotal: 345098,
    votesCountValid: 336384,
    votesCountInvalid: 8714,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 185691 },
      { partyId: 2, partyName: "MHP", vote: 30882 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4249 },
      { partyId: 4, partyName: "VATAN", vote: 571 },
      { partyId: 5, partyName: "HDP", vote: 51641 },
      { partyId: 6, partyName: "CHP", vote: 39947 },
      { partyId: 7, partyName: "SP", vote: 5547 },
      { partyId: 8, partyName: "İYİP", vote: 17856 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2280,
    union2Vote: 363,
    parliamentarianCount: 5,
  },
  {
    id: 3,
    name: "AFYONKARAHİSAR",
    voterCountTotal: 507706,
    votesCountTotal: 459166,
    votesCountValid: 447355,
    votesCountInvalid: 11811,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 248264 },
      { partyId: 2, partyName: "MHP", vote: 63233 },
      { partyId: 3, partyName: "HUDAPAR", vote: 977 },
      { partyId: 4, partyName: "VATAN", vote: 1138 },
      { partyId: 5, partyName: "HDP", vote: 3382 },
      { partyId: 6, partyName: "CHP", vote: 64241 },
      { partyId: 7, partyName: "SP", vote: 4997 },
      { partyId: 8, partyName: "İYİP", vote: 61123 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5846,
    union2Vote: 880,
    parliamentarianCount: 6,
  },
  {
    id: 4,
    name: "AĞRI",
    voterCountTotal: 296375,
    votesCountTotal: 232345,
    votesCountValid: 224267,
    votesCountInvalid: 8078,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 63032 },
      { partyId: 2, partyName: "MHP", vote: 5244 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1731 },
      { partyId: 4, partyName: "VATAN", vote: 402 },
      { partyId: 5, partyName: "HDP", vote: 142683 },
      { partyId: 6, partyName: "CHP", vote: 5496 },
      { partyId: 7, partyName: "SP", vote: 1839 },
      { partyId: 8, partyName: "İYİP", vote: 3553 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 139 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 148 },
    ],
    // bagimsiz_toplam_oy: 287,
    union1Vote: 821,
    union2Vote: 153,
    parliamentarianCount: 4,
  },
  {
    id: 68,
    name: "AKSARAY",
    voterCountTotal: 267068,
    votesCountTotal: 232175,
    votesCountValid: 226978,
    votesCountInvalid: 5197,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 127750 },
      { partyId: 2, partyName: "MHP", vote: 47501 },
      { partyId: 3, partyName: "HUDAPAR", vote: 639 },
      { partyId: 4, partyName: "VATAN", vote: 441 },
      { partyId: 5, partyName: "HDP", vote: 2461 },
      { partyId: 6, partyName: "CHP", vote: 21912 },
      { partyId: 7, partyName: "SP", vote: 1899 },
      { partyId: 8, partyName: "İYİP", vote: 24375 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3337,
    union2Vote: 351,
    parliamentarianCount: 4,
  },
  {
    id: 5,
    name: "AMASYA",
    voterCountTotal: 246896,
    votesCountTotal: 225566,
    votesCountValid: 220743,
    votesCountInvalid: 4823,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 103401 },
      { partyId: 2, partyName: "MHP", vote: 27693 },
      { partyId: 3, partyName: "HUDAPAR", vote: 359 },
      { partyId: 4, partyName: "VATAN", vote: 447 },
      { partyId: 5, partyName: "HDP", vote: 3982 },
      { partyId: 6, partyName: "CHP", vote: 55100 },
      { partyId: 7, partyName: "SP", vote: 2483 },
      { partyId: 8, partyName: "İYİP", vote: 27278 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2350,
    union2Vote: 467,
    parliamentarianCount: 3,
  },
  {
    id: 6,
    name: "ANKARA-1",
    voterCountTotal: 1401859,
    votesCountTotal: 1250107,
    votesCountValid: 1231433,
    votesCountInvalid: 18674,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 371732 },
      { partyId: 2, partyName: "MHP", vote: 132996 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1146 },
      { partyId: 4, partyName: "VATAN", vote: 3178 },
      { partyId: 5, partyName: "HDP", vote: 105479 },
      { partyId: 6, partyName: "CHP", vote: 443750 },
      { partyId: 7, partyName: "SP", vote: 17080 },
      { partyId: 8, partyName: "İYİP", vote: 155048 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 254 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 75 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 695 },
    ],
    // bagimsiz_toplam_oy: 1024,
    union1Vote: 10342,
    union2Vote: 4349,
    parliamentarianCount: 13,
  },
  {
    id: 6,
    name: "ANKARA-2",
    voterCountTotal: 1185237,
    votesCountTotal: 1056573,
    votesCountValid: 1040194,
    votesCountInvalid: 16379,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 531052 },
      { partyId: 2, partyName: "MHP", vote: 157509 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1226 },
      { partyId: 4, partyName: "VATAN", vote: 1952 },
      { partyId: 5, partyName: "HDP", vote: 39635 },
      { partyId: 6, partyName: "CHP", vote: 182117 },
      { partyId: 7, partyName: "SP", vote: 16220 },
      { partyId: 8, partyName: "İYİP", vote: 110483 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 13379,
    union2Vote: 2344,
    parliamentarianCount: 11,
  },
  {
    id: 6,
    name: "ANKARA-3",
    voterCountTotal: 1322490,
    votesCountTotal: 1185636,
    votesCountValid: 1168663,
    votesCountInvalid: 16973,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 476236 },
      { partyId: 2, partyName: "MHP", vote: 165929 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1325 },
      { partyId: 4, partyName: "VATAN", vote: 2234 },
      { partyId: 5, partyName: "HDP", vote: 63678 },
      { partyId: 6, partyName: "CHP", vote: 280568 },
      { partyId: 7, partyName: "SP", vote: 18827 },
      { partyId: 8, partyName: "İYİP", vote: 159397 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 166 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 303 },
    ],
    // bagimsiz_toplam_oy: 469,
    union1Vote: 12546,
    union2Vote: 3586,
    parliamentarianCount: 12,
  },
  {
    id: 7,
    name: "ANTALYA",
    voterCountTotal: 1683522,
    votesCountTotal: 1468770,
    votesCountValid: 1435890,
    votesCountInvalid: 32880,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 494530 },
      { partyId: 2, partyName: "MHP", vote: 146216 },
      { partyId: 3, partyName: "HUDAPAR", vote: 3131 },
      { partyId: 4, partyName: "VATAN", vote: 3798 },
      { partyId: 5, partyName: "HDP", vote: 100782 },
      { partyId: 6, partyName: "CHP", vote: 423783 },
      { partyId: 7, partyName: "SP", vote: 13871 },
      { partyId: 8, partyName: "İYİP", vote: 248494 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 424 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 41 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 566 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 147 },
      { partyId: -5, partyName: "Bağımsız 5", vote: 107 },
    ],
    // bagimsiz_toplam_oy: 1285,
    union1Vote: 12237,
    union2Vote: 4499,
    parliamentarianCount: 17,
  },
  {
    id: 75,
    name: "ARDAHAN",
    voterCountTotal: 69575,
    votesCountTotal: 58863,
    votesCountValid: 56674,
    votesCountInvalid: 2189,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 20796 },
      { partyId: 2, partyName: "MHP", vote: 3816 },
      { partyId: 3, partyName: "HUDAPAR", vote: 203 },
      { partyId: 4, partyName: "VATAN", vote: 202 },
      { partyId: 5, partyName: "HDP", vote: 13358 },
      { partyId: 6, partyName: "CHP", vote: 14804 },
      { partyId: 7, partyName: "SP", vote: 572 },
      { partyId: 8, partyName: "İYİP", vote: 2923 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 435,
    union2Vote: 142,
    parliamentarianCount: 2,
  },
  {
    id: 8,
    name: "ARTVİN",
    voterCountTotal: 131386,
    votesCountTotal: 115066,
    votesCountValid: 111991,
    votesCountInvalid: 3075,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 44975 },
      { partyId: 2, partyName: "MHP", vote: 11496 },
      { partyId: 3, partyName: "HUDAPAR", vote: 325 },
      { partyId: 4, partyName: "VATAN", vote: 423 },
      { partyId: 5, partyName: "HDP", vote: 5076 },
      { partyId: 6, partyName: "CHP", vote: 36358 },
      { partyId: 7, partyName: "SP", vote: 1653 },
      { partyId: 8, partyName: "İYİP", vote: 11685 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1102,
    union2Vote: 350,
    parliamentarianCount: 2,
  },
  {
    id: 9,
    name: "AYDIN",
    voterCountTotal: 816894,
    votesCountTotal: 726243,
    votesCountValid: 709539,
    votesCountInvalid: 16704,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 226369 },
      { partyId: 2, partyName: "MHP", vote: 57452 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1795 },
      { partyId: 4, partyName: "VATAN", vote: 2594 },
      { partyId: 5, partyName: "HDP", vote: 64644 },
      { partyId: 6, partyName: "CHP", vote: 244459 },
      { partyId: 7, partyName: "SP", vote: 4972 },
      { partyId: 8, partyName: "İYİP", vote: 107254 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5032,
    union2Vote: 2297,
    parliamentarianCount: 8,
  },
  {
    id: 10,
    name: "BALIKESİR",
    voterCountTotal: 947177,
    votesCountTotal: 858214,
    votesCountValid: 838607,
    votesCountInvalid: 19607,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 344499 },
      { partyId: 2, partyName: "MHP", vote: 63300 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1500 },
      { partyId: 4, partyName: "VATAN", vote: 2812 },
      { partyId: 5, partyName: "HDP", vote: 32275 },
      { partyId: 6, partyName: "CHP", vote: 257957 },
      { partyId: 7, partyName: "SP", vote: 9877 },
      { partyId: 8, partyName: "İYİP", vote: 126162 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 225 },
    ],
    // bagimsiz_toplam_oy: 225,
    union1Vote: 6665,
    union2Vote: 2549,
    parliamentarianCount: 9,
  },
  {
    id: 74,
    name: "BARTIN",
    voterCountTotal: 146984,
    votesCountTotal: 128658,
    votesCountValid: 123095,
    votesCountInvalid: 5563,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 57715 },
      { partyId: 2, partyName: "MHP", vote: 21299 },
      { partyId: 3, partyName: "HUDAPAR", vote: 345 },
      { partyId: 4, partyName: "VATAN", vote: 662 },
      { partyId: 5, partyName: "HDP", vote: 1502 },
      { partyId: 6, partyName: "CHP", vote: 31654 },
      { partyId: 7, partyName: "SP", vote: 2661 },
      { partyId: 8, partyName: "İYİP", vote: 7257 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1500,
    union2Vote: 330,
    parliamentarianCount: 2,
  },
  {
    id: 72,
    name: "BATMAN",
    voterCountTotal: 342380,
    votesCountTotal: 293091,
    votesCountValid: 284060,
    votesCountInvalid: 9031,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 68398 },
      { partyId: 2, partyName: "MHP", vote: 2857 },
      { partyId: 3, partyName: "HUDAPAR", vote: 0 },
      { partyId: 4, partyName: "VATAN", vote: 420 },
      { partyId: 5, partyName: "HDP", vote: 180318 },
      { partyId: 6, partyName: "CHP", vote: 3796 },
      { partyId: 7, partyName: "SP", vote: 9099 },
      { partyId: 8, partyName: "İYİP", vote: 3174 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 15998 },
    ],
    // bagimsiz_toplam_oy: 15998,
    union1Vote: 633,
    union2Vote: 231,
    parliamentarianCount: 5,
  },
  {
    id: 69,
    name: "BAYBURT",
    voterCountTotal: 56249,
    votesCountTotal: 48364,
    votesCountValid: 47637,
    votesCountInvalid: 727,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 27453 },
      { partyId: 2, partyName: "MHP", vote: 13345 },
      { partyId: 3, partyName: "HUDAPAR", vote: 77 },
      { partyId: 4, partyName: "VATAN", vote: 47 },
      { partyId: 5, partyName: "HDP", vote: 338 },
      { partyId: 6, partyName: "CHP", vote: 1835 },
      { partyId: 7, partyName: "SP", vote: 1582 },
      { partyId: 8, partyName: "İYİP", vote: 2960 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 662,
    union2Vote: 42,
    parliamentarianCount: 1,
  },
  {
    id: 11,
    name: "BİLECİK",
    voterCountTotal: 154403,
    votesCountTotal: 140203,
    votesCountValid: 137214,
    votesCountInvalid: 2989,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 59063 },
      { partyId: 2, partyName: "MHP", vote: 12873 },
      { partyId: 3, partyName: "HUDAPAR", vote: 454 },
      { partyId: 4, partyName: "VATAN", vote: 375 },
      { partyId: 5, partyName: "HDP", vote: 4040 },
      { partyId: 6, partyName: "CHP", vote: 39070 },
      { partyId: 7, partyName: "SP", vote: 1551 },
      { partyId: 8, partyName: "İYİP", vote: 19788 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1160,
    union2Vote: 407,
    parliamentarianCount: 2,
  },
  {
    id: 12,
    name: "BİNGÖL",
    voterCountTotal: 181265,
    votesCountTotal: 147204,
    votesCountValid: 140415,
    votesCountInvalid: 6789,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 77773 },
      { partyId: 2, partyName: "MHP", vote: 8154 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6296 },
      { partyId: 4, partyName: "VATAN", vote: 332 },
      { partyId: 5, partyName: "HDP", vote: 38050 },
      { partyId: 6, partyName: "CHP", vote: 2540 },
      { partyId: 7, partyName: "SP", vote: 1537 },
      { partyId: 8, partyName: "İYİP", vote: 5733 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 801,
    union2Vote: 129,
    parliamentarianCount: 3,
  },
  {
    id: 13,
    name: "BİTLİS",
    voterCountTotal: 198961,
    votesCountTotal: 165568,
    votesCountValid: 159518,
    votesCountInvalid: 6050,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 71151 },
      { partyId: 2, partyName: "MHP", vote: 6320 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1809 },
      { partyId: 4, partyName: "VATAN", vote: 526 },
      { partyId: 5, partyName: "HDP", vote: 69110 },
      { partyId: 6, partyName: "CHP", vote: 3618 },
      { partyId: 7, partyName: "SP", vote: 1787 },
      { partyId: 8, partyName: "İYİP", vote: 5197 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 741,
    union2Vote: 110,
    parliamentarianCount: 3,
  },
  {
    id: 14,
    name: "BOLU",
    voterCountTotal: 223121,
    votesCountTotal: 199734,
    votesCountValid: 195575,
    votesCountInvalid: 4159,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 101969 },
      { partyId: 2, partyName: "MHP", vote: 29638 },
      { partyId: 3, partyName: "HUDAPAR", vote: 374 },
      { partyId: 4, partyName: "VATAN", vote: 562 },
      { partyId: 5, partyName: "HDP", vote: 3140 },
      { partyId: 6, partyName: "CHP", vote: 39879 },
      { partyId: 7, partyName: "SP", vote: 3023 },
      { partyId: 8, partyName: "İYİP", vote: 16990 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2353,
    union2Vote: 525,
    parliamentarianCount: 3,
  },
  {
    id: 15,
    name: "BURDUR",
    voterCountTotal: 196733,
    votesCountTotal: 177117,
    votesCountValid: 171133,
    votesCountInvalid: 5984,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 73382 },
      { partyId: 2, partyName: "MHP", vote: 21635 },
      { partyId: 3, partyName: "HUDAPAR", vote: 564 },
      { partyId: 4, partyName: "VATAN", vote: 736 },
      { partyId: 5, partyName: "HDP", vote: 2468 },
      { partyId: 6, partyName: "CHP", vote: 34749 },
      { partyId: 7, partyName: "SP", vote: 2659 },
      { partyId: 8, partyName: "İYİP", vote: 34940 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1542,
    union2Vote: 446,
    parliamentarianCount: 3,
  },
  {
    id: 16,
    name: "BURSA-1",
    voterCountTotal: 1102185,
    votesCountTotal: 991424,
    votesCountValid: 972351,
    votesCountInvalid: 19073,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 417554 },
      { partyId: 2, partyName: "MHP", vote: 97058 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1684 },
      { partyId: 4, partyName: "VATAN", vote: 2313 },
      { partyId: 5, partyName: "HDP", vote: 42473 },
      { partyId: 6, partyName: "CHP", vote: 252815 },
      { partyId: 7, partyName: "SP", vote: 16276 },
      { partyId: 8, partyName: "İYİP", vote: 141293 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 250 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 635 },
    ],
    // bagimsiz_toplam_oy: 885,
    union1Vote: 9074,
    union2Vote: 3129,
    parliamentarianCount: 10,
  },
  {
    id: 16,
    name: "BURSA-2",
    voterCountTotal: 1047152,
    votesCountTotal: 938619,
    votesCountValid: 921044,
    votesCountInvalid: 17575,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 453648 },
      { partyId: 2, partyName: "MHP", vote: 107708 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2742 },
      { partyId: 4, partyName: "VATAN", vote: 2248 },
      { partyId: 5, partyName: "HDP", vote: 58408 },
      { partyId: 6, partyName: "CHP", vote: 180172 },
      { partyId: 7, partyName: "SP", vote: 16770 },
      { partyId: 8, partyName: "İYİP", vote: 99348 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 10029,
    union2Vote: 2218,
    parliamentarianCount: 10,
  },
  {
    id: 17,
    name: "ÇANAKKALE",
    voterCountTotal: 407273,
    votesCountTotal: 371045,
    votesCountValid: 362838,
    votesCountInvalid: 8207,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 133986 },
      { partyId: 2, partyName: "MHP", vote: 25038 },
      { partyId: 3, partyName: "HUDAPAR", vote: 699 },
      { partyId: 4, partyName: "VATAN", vote: 1215 },
      { partyId: 5, partyName: "HDP", vote: 12069 },
      { partyId: 6, partyName: "CHP", vote: 124504 },
      { partyId: 7, partyName: "SP", vote: 2803 },
      { partyId: 8, partyName: "İYİP", vote: 62261 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 76 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 187 },
    ],
    // bagimsiz_toplam_oy: 263,
    union1Vote: 2476,
    union2Vote: 1184,
    parliamentarianCount: 4,
  },
  {
    id: 18,
    name: "ÇANKIRI",
    voterCountTotal: 134311,
    votesCountTotal: 118106,
    votesCountValid: 115544,
    votesCountInvalid: 2562,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 68682 },
      { partyId: 2, partyName: "MHP", vote: 23088 },
      { partyId: 3, partyName: "HUDAPAR", vote: 203 },
      { partyId: 4, partyName: "VATAN", vote: 241 },
      { partyId: 5, partyName: "HDP", vote: 702 },
      { partyId: 6, partyName: "CHP", vote: 7347 },
      { partyId: 7, partyName: "SP", vote: 1283 },
      { partyId: 8, partyName: "İYİP", vote: 13998 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1839,
    union2Vote: 225,
    parliamentarianCount: 2,
  },
  {
    id: 19,
    name: "ÇORUM",
    voterCountTotal: 391400,
    votesCountTotal: 356078,
    votesCountValid: 348188,
    votesCountInvalid: 7890,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 181338 },
      { partyId: 2, partyName: "MHP", vote: 49524 },
      { partyId: 3, partyName: "HUDAPAR", vote: 620 },
      { partyId: 4, partyName: "VATAN", vote: 840 },
      { partyId: 5, partyName: "HDP", vote: 11230 },
      { partyId: 6, partyName: "CHP", vote: 71031 },
      { partyId: 7, partyName: "SP", vote: 3827 },
      { partyId: 8, partyName: "İYİP", vote: 29778 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4157,
    union2Vote: 658,
    parliamentarianCount: 4,
  },
  {
    id: 20,
    name: "DENİZLİ",
    voterCountTotal: 749055,
    votesCountTotal: 682660,
    votesCountValid: 663996,
    votesCountInvalid: 18664,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 268289 },
      { partyId: 2, partyName: "MHP", vote: 61458 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1714 },
      { partyId: 4, partyName: "VATAN", vote: 2121 },
      { partyId: 5, partyName: "HDP", vote: 24029 },
      { partyId: 6, partyName: "CHP", vote: 188363 },
      { partyId: 7, partyName: "SP", vote: 5568 },
      { partyId: 8, partyName: "İYİP", vote: 111881 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 573 },
    ],
    // bagimsiz_toplam_oy: 573,
    union1Vote: 5282,
    union2Vote: 2083,
    parliamentarianCount: 7,
  },
  {
    id: 21,
    name: "DİYARBAKIR",
    voterCountTotal: 1024929,
    votesCountTotal: 856317,
    votesCountValid: 826242,
    votesCountInvalid: 30075,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 169529 },
      { partyId: 2, partyName: "MHP", vote: 9932 },
      { partyId: 3, partyName: "HUDAPAR", vote: 0 },
      { partyId: 4, partyName: "VATAN", vote: 1155 },
      { partyId: 5, partyName: "HDP", vote: 554172 },
      { partyId: 6, partyName: "CHP", vote: 16765 },
      { partyId: 7, partyName: "SP", vote: 14110 },
      { partyId: 8, partyName: "İYİP", vote: 22824 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 175 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 186 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 273 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 1098 },
      { partyId: -5, partyName: "Bağımsız 5", vote: 136 },
      { partyId: -6, partyName: "Bağımsız 6", vote: 648 },
      { partyId: -7, partyName: "Bağımsız 7", vote: 35239 },
    ],
    // bagimsiz_toplam_oy: 37755,
    union1Vote: 1828,
    union2Vote: 607,
    parliamentarianCount: 12,
  },
  {
    id: 81,
    name: "DÜZCE",
    voterCountTotal: 268337,
    votesCountTotal: 244322,
    votesCountValid: 239644,
    votesCountInvalid: 4678,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 134668 },
      { partyId: 2, partyName: "MHP", vote: 45633 },
      { partyId: 3, partyName: "HUDAPAR", vote: 303 },
      { partyId: 4, partyName: "VATAN", vote: 624 },
      { partyId: 5, partyName: "HDP", vote: 3818 },
      { partyId: 6, partyName: "CHP", vote: 34608 },
      { partyId: 7, partyName: "SP", vote: 3618 },
      { partyId: 8, partyName: "İYİP", vote: 16372 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3541,
    union2Vote: 496,
    parliamentarianCount: 3,
  },
  {
    id: 22,
    name: "EDİRNE",
    voterCountTotal: 311104,
    votesCountTotal: 275162,
    votesCountValid: 268077,
    votesCountInvalid: 7085,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 74688 },
      { partyId: 2, partyName: "MHP", vote: 13293 },
      { partyId: 3, partyName: "HUDAPAR", vote: 607 },
      { partyId: 4, partyName: "VATAN", vote: 863 },
      { partyId: 5, partyName: "HDP", vote: 8744 },
      { partyId: 6, partyName: "CHP", vote: 124003 },
      { partyId: 7, partyName: "SP", vote: 2783 },
      { partyId: 8, partyName: "İYİP", vote: 42878 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 218 },
    ],
    // bagimsiz_toplam_oy: 218,
    union1Vote: 1247,
    union2Vote: 1033,
    parliamentarianCount: 4,
  },
  {
    id: 23,
    name: "ELAZIĞ",
    voterCountTotal: 412412,
    votesCountTotal: 349331,
    votesCountValid: 340826,
    votesCountInvalid: 8505,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 186167 },
      { partyId: 2, partyName: "MHP", vote: 46713 },
      { partyId: 3, partyName: "HUDAPAR", vote: 5197 },
      { partyId: 4, partyName: "VATAN", vote: 559 },
      { partyId: 5, partyName: "HDP", vote: 33633 },
      { partyId: 6, partyName: "CHP", vote: 35878 },
      { partyId: 7, partyName: "SP", vote: 6119 },
      { partyId: 8, partyName: "İYİP", vote: 26560 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3248,
    union2Vote: 432,
    parliamentarianCount: 5,
  },
  {
    id: 24,
    name: "ERZİNCAN",
    voterCountTotal: 162532,
    votesCountTotal: 146355,
    votesCountValid: 144035,
    votesCountInvalid: 2320,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 64158 },
      { partyId: 2, partyName: "MHP", vote: 27295 },
      { partyId: 3, partyName: "HUDAPAR", vote: 138 },
      { partyId: 4, partyName: "VATAN", vote: 148 },
      { partyId: 5, partyName: "HDP", vote: 7615 },
      { partyId: 6, partyName: "CHP", vote: 37073 },
      { partyId: 7, partyName: "SP", vote: 1595 },
      { partyId: 8, partyName: "İYİP", vote: 6013 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1654,
    union2Vote: 207,
    parliamentarianCount: 2,
  },
  {
    id: 25,
    name: "ERZURUM",
    voterCountTotal: 494291,
    votesCountTotal: 431114,
    votesCountValid: 422817,
    votesCountInvalid: 8297,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 232168 },
      { partyId: 2, partyName: "MHP", vote: 79731 },
      { partyId: 3, partyName: "HUDAPAR", vote: 833 },
      { partyId: 4, partyName: "VATAN", vote: 680 },
      { partyId: 5, partyName: "HDP", vote: 49885 },
      { partyId: 6, partyName: "CHP", vote: 16956 },
      { partyId: 7, partyName: "SP", vote: 7590 },
      { partyId: 8, partyName: "İYİP", vote: 34974 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 6199,
    union2Vote: 571,
    parliamentarianCount: 6,
  },
  {
    id: 26,
    name: "ESKİŞEHİR",
    voterCountTotal: 646221,
    votesCountTotal: 575177,
    votesCountValid: 564067,
    votesCountInvalid: 11110,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 216516 },
      { partyId: 2, partyName: "MHP", vote: 56348 },
      { partyId: 3, partyName: "HUDAPAR", vote: 758 },
      { partyId: 4, partyName: "VATAN", vote: 1398 },
      { partyId: 5, partyName: "HDP", vote: 21797 },
      { partyId: 6, partyName: "CHP", vote: 184576 },
      { partyId: 7, partyName: "SP", vote: 6320 },
      { partyId: 8, partyName: "İYİP", vote: 76077 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 277 },
    ],
    // bagimsiz_toplam_oy: 277,
    union1Vote: 5145,
    union2Vote: 2149,
    parliamentarianCount: 6,
  },
  {
    id: 27,
    name: "GAZİANTEP",
    voterCountTotal: 1216402,
    votesCountTotal: 1039392,
    votesCountValid: 1019525,
    votesCountInvalid: 19867,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 524405 },
      { partyId: 2, partyName: "MHP", vote: 130674 },
      { partyId: 3, partyName: "HUDAPAR", vote: 8703 },
      { partyId: 4, partyName: "VATAN", vote: 1947 },
      { partyId: 5, partyName: "HDP", vote: 119393 },
      { partyId: 6, partyName: "CHP", vote: 153165 },
      { partyId: 7, partyName: "SP", vote: 12337 },
      { partyId: 8, partyName: "İYİP", vote: 68901 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 10891,
    union2Vote: 1534,
    parliamentarianCount: 14,
  },
  {
    id: 28,
    name: "GİRESUN",
    voterCountTotal: 334730,
    votesCountTotal: 290219,
    votesCountValid: 282863,
    votesCountInvalid: 7356,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 151916 },
      { partyId: 2, partyName: "MHP", vote: 30855 },
      { partyId: 3, partyName: "HUDAPAR", vote: 802 },
      { partyId: 4, partyName: "VATAN", vote: 812 },
      { partyId: 5, partyName: "HDP", vote: 2983 },
      { partyId: 6, partyName: "CHP", vote: 50285 },
      { partyId: 7, partyName: "SP", vote: 3568 },
      { partyId: 8, partyName: "İYİP", vote: 41642 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3356,
    union2Vote: 680,
    parliamentarianCount: 4,
  },
  {
    id: 29,
    name: "GÜMÜŞHANE",
    voterCountTotal: 100853,
    votesCountTotal: 80733,
    votesCountValid: 78858,
    votesCountInvalid: 1875,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 44961 },
      { partyId: 2, partyName: "MHP", vote: 16516 },
      { partyId: 3, partyName: "HUDAPAR", vote: 220 },
      { partyId: 4, partyName: "VATAN", vote: 178 },
      { partyId: 5, partyName: "HDP", vote: 654 },
      { partyId: 6, partyName: "CHP", vote: 5624 },
      { partyId: 7, partyName: "SP", vote: 1586 },
      { partyId: 8, partyName: "İYİP", vote: 9119 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1154,
    union2Vote: 126,
    parliamentarianCount: 2,
  },
  {
    id: 30,
    name: "HAKKARİ",
    voterCountTotal: 168438,
    votesCountTotal: 140276,
    votesCountValid: 135566,
    votesCountInvalid: 4710,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 25877 },
      { partyId: 2, partyName: "MHP", vote: 4831 },
      { partyId: 3, partyName: "HUDAPAR", vote: 792 },
      { partyId: 4, partyName: "VATAN", vote: 271 },
      { partyId: 5, partyName: "HDP", vote: 97337 },
      { partyId: 6, partyName: "CHP", vote: 4088 },
      { partyId: 7, partyName: "SP", vote: 714 },
      { partyId: 8, partyName: "İYİP", vote: 1656 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 402,
    union2Vote: 87,
    parliamentarianCount: 3,
  },
  {
    id: 31,
    name: "HATAY",
    voterCountTotal: 1042335,
    votesCountTotal: 925282,
    votesCountValid: 911280,
    votesCountInvalid: 14002,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 325525 },
      { partyId: 2, partyName: "MHP", vote: 133407 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1511 },
      { partyId: 4, partyName: "VATAN", vote: 1290 },
      { partyId: 5, partyName: "HDP", vote: 98645 },
      { partyId: 6, partyName: "CHP", vote: 282429 },
      { partyId: 7, partyName: "SP", vote: 8236 },
      { partyId: 8, partyName: "İYİP", vote: 60237 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7568,
    union2Vote: 1657,
    parliamentarianCount: 11,
  },
  {
    id: 76,
    name: "IĞDIR",
    voterCountTotal: 119735,
    votesCountTotal: 93297,
    votesCountValid: 91115,
    votesCountInvalid: 2182,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 18007 },
      { partyId: 2, partyName: "MHP", vote: 22222 },
      { partyId: 3, partyName: "HUDAPAR", vote: 198 },
      { partyId: 4, partyName: "VATAN", vote: 203 },
      { partyId: 5, partyName: "HDP", vote: 41057 },
      { partyId: 6, partyName: "CHP", vote: 2168 },
      { partyId: 7, partyName: "SP", vote: 1856 },
      { partyId: 8, partyName: "İYİP", vote: 5404 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 607,
    union2Vote: 115,
    parliamentarianCount: 2,
  },
  {
    id: 32,
    name: "ISPARTA",
    voterCountTotal: 312990,
    votesCountTotal: 278869,
    votesCountValid: 271606,
    votesCountInvalid: 7263,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 129357 },
      { partyId: 2, partyName: "MHP", vote: 36093 },
      { partyId: 3, partyName: "HUDAPAR", vote: 710 },
      { partyId: 4, partyName: "VATAN", vote: 897 },
      { partyId: 5, partyName: "HDP", vote: 4503 },
      { partyId: 6, partyName: "CHP", vote: 44731 },
      { partyId: 7, partyName: "SP", vote: 4147 },
      { partyId: 8, partyName: "İYİP", vote: 51168 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2906,
    union2Vote: 738,
    parliamentarianCount: 4,
  },
  {
    id: 34,
    name: "İSTANBUL-1",
    voterCountTotal: 3822256,
    votesCountTotal: 3403734,
    votesCountValid: 3350363,
    votesCountInvalid: 53371,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1378837 },
      { partyId: 2, partyName: "MHP", vote: 274707 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4766 },
      { partyId: 4, partyName: "VATAN", vote: 7322 },
      { partyId: 5, partyName: "HDP", vote: 372793 },
      { partyId: 6, partyName: "CHP", vote: 979474 },
      { partyId: 7, partyName: "SP", vote: 52760 },
      { partyId: 8, partyName: "İYİP", vote: 277801 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 1714 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 189 },
    ],
    // bagimsiz_toplam_oy: 1903,
    union1Vote: 26274,
    union2Vote: 9911,
    parliamentarianCount: 35,
  },
  {
    id: 34,
    name: "İSTANBUL-2",
    voterCountTotal: 3044957,
    votesCountTotal: 2657989,
    votesCountValid: 2614767,
    votesCountInvalid: 43222,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1177007 },
      { partyId: 2, partyName: "MHP", vote: 212243 },
      { partyId: 3, partyName: "HUDAPAR", vote: 5320 },
      { partyId: 4, partyName: "VATAN", vote: 5026 },
      { partyId: 5, partyName: "HDP", vote: 317391 },
      { partyId: 6, partyName: "CHP", vote: 653961 },
      { partyId: 7, partyName: "SP", vote: 41329 },
      { partyId: 8, partyName: "İYİP", vote: 201320 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 810 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 105 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 138 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 117 },
    ],
    // bagimsiz_toplam_oy: 1170,
    union1Vote: 21480,
    union2Vote: 7181,
    parliamentarianCount: 28,
  },
  {
    id: 34,
    name: "İSTANBUL-3",
    voterCountTotal: 3706330,
    votesCountTotal: 3242484,
    votesCountValid: 3189988,
    votesCountInvalid: 52496,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1326931 },
      { partyId: 2, partyName: "MHP", vote: 270288 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6514 },
      { partyId: 4, partyName: "VATAN", vote: 5738 },
      { partyId: 5, partyName: "HDP", vote: 456265 },
      { partyId: 6, partyName: "CHP", vote: 814809 },
      { partyId: 7, partyName: "SP", vote: 43637 },
      { partyId: 8, partyName: "İYİP", vote: 264799 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 657 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 137 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 108 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 105 },
    ],
    // bagimsiz_toplam_oy: 1007,
    union1Vote: 25218,
    union2Vote: 8456,
    parliamentarianCount: 35,
  },
  {
    id: 35,
    name: "İZMİR-1",
    voterCountTotal: 1579092,
    votesCountTotal: 1397565,
    votesCountValid: 1373392,
    votesCountInvalid: 24173,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 385120 },
      { partyId: 2, partyName: "MHP", vote: 79599 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2276 },
      { partyId: 4, partyName: "VATAN", vote: 4223 },
      { partyId: 5, partyName: "HDP", vote: 169996 },
      { partyId: 6, partyName: "CHP", vote: 573793 },
      { partyId: 7, partyName: "SP", vote: 10830 },
      { partyId: 8, partyName: "İYİP", vote: 146596 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 272 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 687 },
    ],
    // bagimsiz_toplam_oy: 959,
    union1Vote: 9097,
    union2Vote: 4882,
    parliamentarianCount: 14,
  },
  {
    id: 35,
    name: "İZMİR-2",
    voterCountTotal: 1653277,
    votesCountTotal: 1483365,
    votesCountValid: 1454605,
    votesCountInvalid: 28760,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 406163 },
      { partyId: 2, partyName: "MHP", vote: 96700 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2449 },
      { partyId: 4, partyName: "VATAN", vote: 4725 },
      { partyId: 5, partyName: "HDP", vote: 149819 },
      { partyId: 6, partyName: "CHP", vote: 615033 },
      { partyId: 7, partyName: "SP", vote: 11773 },
      { partyId: 8, partyName: "İYİP", vote: 166950 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 993 },
    ],
    // bagimsiz_toplam_oy: 993,
    union1Vote: 9315,
    union2Vote: 5467,
    parliamentarianCount: 14,
  },
  {
    id: 46,
    name: "KAHRAMANMARAŞ",
    voterCountTotal: 739457,
    votesCountTotal: 661140,
    votesCountValid: 648790,
    votesCountInvalid: 12350,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 380706 },
      { partyId: 2, partyName: "MHP", vote: 107607 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1531 },
      { partyId: 4, partyName: "VATAN", vote: 1323 },
      { partyId: 5, partyName: "HDP", vote: 22252 },
      { partyId: 6, partyName: "CHP", vote: 61782 },
      { partyId: 7, partyName: "SP", vote: 9908 },
      { partyId: 8, partyName: "İYİP", vote: 63681 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7388,
    union2Vote: 807,
    parliamentarianCount: 8,
  },
  {
    id: 78,
    name: "KARABÜK",
    voterCountTotal: 176018,
    votesCountTotal: 154405,
    votesCountValid: 150057,
    votesCountInvalid: 4348,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 80848 },
      { partyId: 2, partyName: "MHP", vote: 20635 },
      { partyId: 3, partyName: "HUDAPAR", vote: 323 },
      { partyId: 4, partyName: "VATAN", vote: 552 },
      { partyId: 5, partyName: "HDP", vote: 1486 },
      { partyId: 6, partyName: "CHP", vote: 24947 },
      { partyId: 7, partyName: "SP", vote: 2625 },
      { partyId: 8, partyName: "İYİP", vote: 18641 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1763,
    union2Vote: 374,
    parliamentarianCount: 3,
  },
  {
    id: 70,
    name: "KARAMAN",
    voterCountTotal: 173867,
    votesCountTotal: 156830,
    votesCountValid: 152972,
    votesCountInvalid: 3858,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 81960 },
      { partyId: 2, partyName: "MHP", vote: 23241 },
      { partyId: 3, partyName: "HUDAPAR", vote: 356 },
      { partyId: 4, partyName: "VATAN", vote: 521 },
      { partyId: 5, partyName: "HDP", vote: 1671 },
      { partyId: 6, partyName: "CHP", vote: 24774 },
      { partyId: 7, partyName: "SP", vote: 2446 },
      { partyId: 8, partyName: "İYİP", vote: 18003 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1877,
    union2Vote: 300,
    parliamentarianCount: 3,
  },
  {
    id: 36,
    name: "KARS",
    voterCountTotal: 182194,
    votesCountTotal: 147467,
    votesCountValid: 143051,
    votesCountInvalid: 4416,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 53620 },
      { partyId: 2, partyName: "MHP", vote: 10309 },
      { partyId: 3, partyName: "HUDAPAR", vote: 424 },
      { partyId: 4, partyName: "VATAN", vote: 414 },
      { partyId: 5, partyName: "HDP", vote: 46285 },
      { partyId: 6, partyName: "CHP", vote: 20346 },
      { partyId: 7, partyName: "SP", vote: 979 },
      { partyId: 8, partyName: "İYİP", vote: 10674 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 993,
    union2Vote: 222,
    parliamentarianCount: 3,
  },
  {
    id: 37,
    name: "KASTAMONU",
    voterCountTotal: 285917,
    votesCountTotal: 249191,
    votesCountValid: 241904,
    votesCountInvalid: 7287,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 126395 },
      { partyId: 2, partyName: "MHP", vote: 49472 },
      { partyId: 3, partyName: "HUDAPAR", vote: 727 },
      { partyId: 4, partyName: "VATAN", vote: 1075 },
      { partyId: 5, partyName: "HDP", vote: 1524 },
      { partyId: 6, partyName: "CHP", vote: 37463 },
      { partyId: 7, partyName: "SP", vote: 2300 },
      { partyId: 8, partyName: "İYİP", vote: 22948 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3496,
    union2Vote: 526,
    parliamentarianCount: 3,
  },
  {
    id: 38,
    name: "KAYSERİ",
    voterCountTotal: 954408,
    votesCountTotal: 864726,
    votesCountValid: 848702,
    votesCountInvalid: 16024,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 429421 },
      { partyId: 2, partyName: "MHP", vote: 185831 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1479 },
      { partyId: 4, partyName: "VATAN", vote: 1274 },
      { partyId: 5, partyName: "HDP", vote: 16193 },
      { partyId: 6, partyName: "CHP", vote: 103603 },
      { partyId: 7, partyName: "SP", vote: 14836 },
      { partyId: 8, partyName: "İYİP", vote: 95270 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 795 },
    ],
    // bagimsiz_toplam_oy: 795,
    union1Vote: 12296,
    union2Vote: 1484,
    parliamentarianCount: 10,
  },
  {
    id: 71,
    name: "KIRIKKALE",
    voterCountTotal: 199395,
    votesCountTotal: 173824,
    votesCountValid: 170629,
    votesCountInvalid: 3195,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 74118 },
      { partyId: 2, partyName: "MHP", vote: 42204 },
      { partyId: 3, partyName: "HUDAPAR", vote: 292 },
      { partyId: 4, partyName: "VATAN", vote: 300 },
      { partyId: 5, partyName: "HDP", vote: 1881 },
      { partyId: 6, partyName: "CHP", vote: 25950 },
      { partyId: 7, partyName: "SP", vote: 2077 },
      { partyId: 8, partyName: "İYİP", vote: 23807 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2378,
    union2Vote: 396,
    parliamentarianCount: 3,
  },
  {
    id: 39,
    name: "KIRKLARELİ",
    voterCountTotal: 273082,
    votesCountTotal: 246416,
    votesCountValid: 241347,
    votesCountInvalid: 5069,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 63019 },
      { partyId: 2, partyName: "MHP", vote: 11526 },
      { partyId: 3, partyName: "HUDAPAR", vote: 358 },
      { partyId: 4, partyName: "VATAN", vote: 675 },
      { partyId: 5, partyName: "HDP", vote: 7123 },
      { partyId: 6, partyName: "CHP", vote: 116842 },
      { partyId: 7, partyName: "SP", vote: 1442 },
      { partyId: 8, partyName: "İYİP", vote: 40301 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 61 },
    ],
    // bagimsiz_toplam_oy: 61,
    union1Vote: 1030,
    union2Vote: 903,
    parliamentarianCount: 3,
  },
  {
    id: 40,
    name: "KIRŞEHİR",
    voterCountTotal: 166167,
    votesCountTotal: 143297,
    votesCountValid: 139891,
    votesCountInvalid: 3406,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 57230 },
      { partyId: 2, partyName: "MHP", vote: 24071 },
      { partyId: 3, partyName: "HUDAPAR", vote: 254 },
      { partyId: 4, partyName: "VATAN", vote: 283 },
      { partyId: 5, partyName: "HDP", vote: 6029 },
      { partyId: 6, partyName: "CHP", vote: 36092 },
      { partyId: 7, partyName: "SP", vote: 1404 },
      { partyId: 8, partyName: "İYİP", vote: 14427 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 101 },
    ],
    // bagimsiz_toplam_oy: 101,
    union1Vote: 1669,
    union2Vote: 319,
    parliamentarianCount: 2,
  },
  {
    id: 79,
    name: "KİLİS",
    voterCountTotal: 86080,
    votesCountTotal: 75129,
    votesCountValid: 73424,
    votesCountInvalid: 1705,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 37305 },
      { partyId: 2, partyName: "MHP", vote: 15223 },
      { partyId: 3, partyName: "HUDAPAR", vote: 177 },
      { partyId: 4, partyName: "VATAN", vote: 125 },
      { partyId: 5, partyName: "HDP", vote: 1347 },
      { partyId: 6, partyName: "CHP", vote: 10647 },
      { partyId: 7, partyName: "SP", vote: 1002 },
      { partyId: 8, partyName: "İYİP", vote: 7598 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 845,
    union2Vote: 130,
    parliamentarianCount: 2,
  },
  {
    id: 41,
    name: "KOCAELİ",
    voterCountTotal: 1336401,
    votesCountTotal: 1198849,
    votesCountValid: 1175662,
    votesCountInvalid: 23187,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 566482 },
      { partyId: 2, partyName: "MHP", vote: 134792 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1843 },
      { partyId: 4, partyName: "VATAN", vote: 2014 },
      { partyId: 5, partyName: "HDP", vote: 82860 },
      { partyId: 6, partyName: "CHP", vote: 237366 },
      { partyId: 7, partyName: "SP", vote: 26161 },
      { partyId: 8, partyName: "İYİP", vote: 123644 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 124 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 376 },
    ],
    // bagimsiz_toplam_oy: 500,
    union1Vote: 12151,
    union2Vote: 3111,
    parliamentarianCount: 14,
  },
  {
    id: 42,
    name: "KONYA",
    voterCountTotal: 1505540,
    votesCountTotal: 1341859,
    votesCountValid: 1312952,
    votesCountInvalid: 28907,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 783116 },
      { partyId: 2, partyName: "MHP", vote: 206466 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2787 },
      { partyId: 4, partyName: "VATAN", vote: 1996 },
      { partyId: 5, partyName: "HDP", vote: 43228 },
      { partyId: 6, partyName: "CHP", vote: 123746 },
      { partyId: 7, partyName: "SP", vote: 31307 },
      { partyId: 8, partyName: "İYİP", vote: 119710 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 420 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 176 },
    ],
    // bagimsiz_toplam_oy: 596,
    union1Vote: 14734,
    union2Vote: 1856,
    parliamentarianCount: 15,
  },
  {
    id: 43,
    name: "KÜTAHYA",
    voterCountTotal: 422653,
    votesCountTotal: 386024,
    votesCountValid: 377486,
    votesCountInvalid: 8538,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 207307 },
      { partyId: 2, partyName: "MHP", vote: 70911 },
      { partyId: 3, partyName: "HUDAPAR", vote: 811 },
      { partyId: 4, partyName: "VATAN", vote: 900 },
      { partyId: 5, partyName: "HDP", vote: 2678 },
      { partyId: 6, partyName: "CHP", vote: 47175 },
      { partyId: 7, partyName: "SP", vote: 6896 },
      { partyId: 8, partyName: "İYİP", vote: 40808 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4542,
    union2Vote: 729,
    parliamentarianCount: 5,
  },
  {
    id: 44,
    name: "MALATYA",
    voterCountTotal: 555931,
    votesCountTotal: 487151,
    votesCountValid: 478686,
    votesCountInvalid: 8465,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 258166 },
      { partyId: 2, partyName: "MHP", vote: 78401 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1619 },
      { partyId: 4, partyName: "VATAN", vote: 655 },
      { partyId: 5, partyName: "HDP", vote: 32081 },
      { partyId: 6, partyName: "CHP", vote: 80020 },
      { partyId: 7, partyName: "SP", vote: 7288 },
      { partyId: 8, partyName: "İYİP", vote: 20456 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4184,
    union2Vote: 565,
    parliamentarianCount: 6,
  },
  {
    id: 45,
    name: "MANİSA",
    voterCountTotal: 1046410,
    votesCountTotal: 953742,
    votesCountValid: 930198,
    votesCountInvalid: 23544,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 370178 },
      { partyId: 2, partyName: "MHP", vote: 107505 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2545 },
      { partyId: 4, partyName: "VATAN", vote: 2739 },
      { partyId: 5, partyName: "HDP", vote: 62198 },
      { partyId: 6, partyName: "CHP", vote: 247465 },
      { partyId: 7, partyName: "SP", vote: 8725 },
      { partyId: 8, partyName: "İYİP", vote: 128843 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 8124,
    union2Vote: 2471,
    parliamentarianCount: 10,
  },
  {
    id: 47,
    name: "MARDİN",
    voterCountTotal: 471225,
    votesCountTotal: 395732,
    votesCountValid: 385281,
    votesCountInvalid: 10451,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 114683 },
      { partyId: 2, partyName: "MHP", vote: 9474 },
      { partyId: 3, partyName: "HUDAPAR", vote: 8253 },
      { partyId: 4, partyName: "VATAN", vote: 641 },
      { partyId: 5, partyName: "HDP", vote: 233657 },
      { partyId: 6, partyName: "CHP", vote: 11035 },
      { partyId: 7, partyName: "SP", vote: 3188 },
      { partyId: 8, partyName: "İYİP", vote: 4000 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 96 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 254 },
    ],
    // bagimsiz_toplam_oy: 350,
    union1Vote: 1136,
    union2Vote: 205,
    parliamentarianCount: 6,
  },
  {
    id: 33,
    name: "MERSİN",
    voterCountTotal: 1272836,
    votesCountTotal: 1123450,
    votesCountValid: 1102558,
    votesCountInvalid: 20892,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 307858 },
      { partyId: 2, partyName: "MHP", vote: 142295 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4486 },
      { partyId: 4, partyName: "VATAN", vote: 2391 },
      { partyId: 5, partyName: "HDP", vote: 186663 },
      { partyId: 6, partyName: "CHP", vote: 298172 },
      { partyId: 7, partyName: "SP", vote: 7556 },
      { partyId: 8, partyName: "İYİP", vote: 152763 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 374 },
    ],
    // bagimsiz_toplam_oy: 374,
    union1Vote: 8372,
    union2Vote: 2538,
    parliamentarianCount: 13,
  },
  {
    id: 48,
    name: "MUĞLA",
    voterCountTotal: 725909,
    votesCountTotal: 642952,
    votesCountValid: 628627,
    votesCountInvalid: 14325,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 172610 },
      { partyId: 2, partyName: "MHP", vote: 40474 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1378 },
      { partyId: 4, partyName: "VATAN", vote: 2615 },
      { partyId: 5, partyName: "HDP", vote: 40278 },
      { partyId: 6, partyName: "CHP", vote: 261387 },
      { partyId: 7, partyName: "SP", vote: 3811 },
      { partyId: 8, partyName: "İYİP", vote: 106074 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3524,
    union2Vote: 2385,
    parliamentarianCount: 7,
  },
  {
    id: 49,
    name: "MUŞ",
    voterCountTotal: 228826,
    votesCountTotal: 189275,
    votesCountValid: 183037,
    votesCountInvalid: 6238,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 58265 },
      { partyId: 2, partyName: "MHP", vote: 6593 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2784 },
      { partyId: 4, partyName: "VATAN", vote: 391 },
      { partyId: 5, partyName: "HDP", vote: 101744 },
      { partyId: 6, partyName: "CHP", vote: 3661 },
      { partyId: 7, partyName: "SP", vote: 1664 },
      { partyId: 8, partyName: "İYİP", vote: 7935 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 584,
    union2Vote: 94,
    parliamentarianCount: 3,
  },
  {
    id: 50,
    name: "NEVŞEHİR",
    voterCountTotal: 210901,
    votesCountTotal: 189162,
    votesCountValid: 185381,
    votesCountInvalid: 3781,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 98583 },
      { partyId: 2, partyName: "MHP", vote: 33658 },
      { partyId: 3, partyName: "HUDAPAR", vote: 551 },
      { partyId: 4, partyName: "VATAN", vote: 418 },
      { partyId: 5, partyName: "HDP", vote: 2335 },
      { partyId: 6, partyName: "CHP", vote: 30686 },
      { partyId: 7, partyName: "SP", vote: 2190 },
      { partyId: 8, partyName: "İYİP", vote: 16960 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2151,
    union2Vote: 324,
    parliamentarianCount: 3,
  },
  {
    id: 51,
    name: "NİĞDE",
    voterCountTotal: 240315,
    votesCountTotal: 210930,
    votesCountValid: 206290,
    votesCountInvalid: 4640,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 89919 },
      { partyId: 2, partyName: "MHP", vote: 43619 },
      { partyId: 3, partyName: "HUDAPAR", vote: 443 },
      { partyId: 4, partyName: "VATAN", vote: 613 },
      { partyId: 5, partyName: "HDP", vote: 2424 },
      { partyId: 6, partyName: "CHP", vote: 41840 },
      { partyId: 7, partyName: "SP", vote: 2501 },
      { partyId: 8, partyName: "İYİP", vote: 24931 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2716,
    union2Vote: 400,
    parliamentarianCount: 3,
  },
  {
    id: 52,
    name: "ORDU",
    voterCountTotal: 558478,
    votesCountTotal: 484245,
    votesCountValid: 470149,
    votesCountInvalid: 14096,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 228861 },
      { partyId: 2, partyName: "MHP", vote: 80514 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1244 },
      { partyId: 4, partyName: "VATAN", vote: 1745 },
      { partyId: 5, partyName: "HDP", vote: 4269 },
      { partyId: 6, partyName: "CHP", vote: 107653 },
      { partyId: 7, partyName: "SP", vote: 5420 },
      { partyId: 8, partyName: "İYİP", vote: 40443 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7340,
    union2Vote: 1049,
    parliamentarianCount: 6,
  },
  {
    id: 80,
    name: "OSMANİYE",
    voterCountTotal: 358510,
    votesCountTotal: 308729,
    votesCountValid: 303085,
    votesCountInvalid: 5644,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 108468 },
      { partyId: 2, partyName: "MHP", vote: 98244 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1157 },
      { partyId: 4, partyName: "VATAN", vote: 652 },
      { partyId: 5, partyName: "HDP", vote: 9585 },
      { partyId: 6, partyName: "CHP", vote: 40655 },
      { partyId: 7, partyName: "SP", vote: 3005 },
      { partyId: 8, partyName: "İYİP", vote: 41319 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5113,
    union2Vote: 481,
    parliamentarianCount: 4,
  },
  {
    id: 53,
    name: "RİZE",
    voterCountTotal: 252766,
    votesCountTotal: 222114,
    votesCountValid: 217507,
    votesCountInvalid: 4607,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 141928 },
      { partyId: 2, partyName: "MHP", vote: 27292 },
      { partyId: 3, partyName: "HUDAPAR", vote: 228 },
      { partyId: 4, partyName: "VATAN", vote: 354 },
      { partyId: 5, partyName: "HDP", vote: 2048 },
      { partyId: 6, partyName: "CHP", vote: 28039 },
      { partyId: 7, partyName: "SP", vote: 4136 },
      { partyId: 8, partyName: "İYİP", vote: 13206 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 252 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 24 },
    ],
    // bagimsiz_toplam_oy: 276,
    union1Vote: 2365,
    union2Vote: 397,
    parliamentarianCount: 3,
  },
  {
    id: 54,
    name: "SAKARYA",
    voterCountTotal: 705678,
    votesCountTotal: 637350,
    votesCountValid: 625866,
    votesCountInvalid: 11484,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 365372 },
      { partyId: 2, partyName: "MHP", vote: 86470 },
      { partyId: 3, partyName: "HUDAPAR", vote: 856 },
      { partyId: 4, partyName: "VATAN", vote: 1180 },
      { partyId: 5, partyName: "HDP", vote: 14048 },
      { partyId: 6, partyName: "CHP", vote: 85046 },
      { partyId: 7, partyName: "SP", vote: 13093 },
      { partyId: 8, partyName: "İYİP", vote: 59801 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7898,
    union2Vote: 1352,
    parliamentarianCount: 8,
  },
  {
    id: 55,
    name: "SAMSUN",
    voterCountTotal: 960245,
    votesCountTotal: 848938,
    votesCountValid: 827725,
    votesCountInvalid: 21213,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 430279 },
      { partyId: 2, partyName: "MHP", vote: 136427 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1281 },
      { partyId: 4, partyName: "VATAN", vote: 1748 },
      { partyId: 5, partyName: "HDP", vote: 10645 },
      { partyId: 6, partyName: "CHP", vote: 142905 },
      { partyId: 7, partyName: "SP", vote: 11946 },
      { partyId: 8, partyName: "İYİP", vote: 91779 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 130 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 585 },
    ],
    // bagimsiz_toplam_oy: 715,
    union1Vote: 10969,
    union2Vote: 1891,
    parliamentarianCount: 9,
  },
  {
    id: 56,
    name: "SİİRT",
    voterCountTotal: 180215,
    votesCountTotal: 151462,
    votesCountValid: 146267,
    votesCountInvalid: 5195,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 56417 },
      { partyId: 2, partyName: "MHP", vote: 4951 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1776 },
      { partyId: 4, partyName: "VATAN", vote: 269 },
      { partyId: 5, partyName: "HDP", vote: 76225 },
      { partyId: 6, partyName: "CHP", vote: 3037 },
      { partyId: 7, partyName: "SP", vote: 1376 },
      { partyId: 8, partyName: "İYİP", vote: 2216 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 573,
    union2Vote: 103,
    parliamentarianCount: 3,
  },
  {
    id: 57,
    name: "SİNOP",
    voterCountTotal: 160081,
    votesCountTotal: 140110,
    votesCountValid: 135289,
    votesCountInvalid: 4821,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 74918 },
      { partyId: 2, partyName: "MHP", vote: 9728 },
      { partyId: 3, partyName: "HUDAPAR", vote: 444 },
      { partyId: 4, partyName: "VATAN", vote: 778 },
      { partyId: 5, partyName: "HDP", vote: 2065 },
      { partyId: 6, partyName: "CHP", vote: 33045 },
      { partyId: 7, partyName: "SP", vote: 1529 },
      { partyId: 8, partyName: "İYİP", vote: 12782 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1445,
    union2Vote: 381,
    parliamentarianCount: 2,
  },
  {
    id: 58,
    name: "SİVAS",
    voterCountTotal: 450597,
    votesCountTotal: 404295,
    votesCountValid: 397033,
    votesCountInvalid: 7262,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 217215 },
      { partyId: 2, partyName: "MHP", vote: 76787 },
      { partyId: 3, partyName: "HUDAPAR", vote: 532 },
      { partyId: 4, partyName: "VATAN", vote: 615 },
      { partyId: 5, partyName: "HDP", vote: 6863 },
      { partyId: 6, partyName: "CHP", vote: 60163 },
      { partyId: 7, partyName: "SP", vote: 7103 },
      { partyId: 8, partyName: "İYİP", vote: 27489 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 266 },
    ],
    // bagimsiz_toplam_oy: 266,
    union1Vote: 5151,
    union2Vote: 598,
    parliamentarianCount: 5,
  },
  {
    id: 63,
    name: "ŞANLIURFA",
    voterCountTotal: 1063482,
    votesCountTotal: 864333,
    votesCountValid: 843861,
    votesCountInvalid: 20472,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 444729 },
      { partyId: 2, partyName: "MHP", vote: 78717 },
      { partyId: 3, partyName: "HUDAPAR", vote: 13495 },
      { partyId: 4, partyName: "VATAN", vote: 927 },
      { partyId: 5, partyName: "HDP", vote: 247256 },
      { partyId: 6, partyName: "CHP", vote: 29153 },
      { partyId: 7, partyName: "SP", vote: 11020 },
      { partyId: 8, partyName: "İYİP", vote: 15116 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 3062 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 386 },
    ],
    // bagimsiz_toplam_oy: 3448,
    union1Vote: 5882,
    union2Vote: 531,
    parliamentarianCount: 14,
  },
  {
    id: 73,
    name: "ŞIRNAK",
    voterCountTotal: 268840,
    votesCountTotal: 233565,
    votesCountValid: 226738,
    votesCountInvalid: 6827,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 38884 },
      { partyId: 2, partyName: "MHP", vote: 8808 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4847 },
      { partyId: 4, partyName: "VATAN", vote: 344 },
      { partyId: 5, partyName: "HDP", vote: 162969 },
      { partyId: 6, partyName: "CHP", vote: 5117 },
      { partyId: 7, partyName: "SP", vote: 1016 },
      { partyId: 8, partyName: "İYİP", vote: 4345 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 408 },
    ],
    // bagimsiz_toplam_oy: 408,
    union1Vote: 448,
    union2Vote: 145,
    parliamentarianCount: 4,
  },
  {
    id: 59,
    name: "TEKİRDAĞ",
    voterCountTotal: 737697,
    votesCountTotal: 657317,
    votesCountValid: 644493,
    votesCountInvalid: 12824,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 220408 },
      { partyId: 2, partyName: "MHP", vote: 48657 },
      { partyId: 3, partyName: "HUDAPAR", vote: 904 },
      { partyId: 4, partyName: "VATAN", vote: 1589 },
      { partyId: 5, partyName: "HDP", vote: 40274 },
      { partyId: 6, partyName: "CHP", vote: 250166 },
      { partyId: 7, partyName: "SP", vote: 5052 },
      { partyId: 8, partyName: "İYİP", vote: 77214 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 229 },
    ],
    // bagimsiz_toplam_oy: 229,
    union1Vote: 4394,
    union2Vote: 2168,
    parliamentarianCount: 8,
  },
  {
    id: 60,
    name: "TOKAT",
    voterCountTotal: 424187,
    votesCountTotal: 382498,
    votesCountValid: 374996,
    votesCountInvalid: 7502,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 186939 },
      { partyId: 2, partyName: "MHP", vote: 62460 },
      { partyId: 3, partyName: "HUDAPAR", vote: 615 },
      { partyId: 4, partyName: "VATAN", vote: 664 },
      { partyId: 5, partyName: "HDP", vote: 5999 },
      { partyId: 6, partyName: "CHP", vote: 77812 },
      { partyId: 7, partyName: "SP", vote: 4858 },
      { partyId: 8, partyName: "İYİP", vote: 35649 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4733,
    union2Vote: 605,
    parliamentarianCount: 5,
  },
  {
    id: 61,
    name: "TRABZON",
    voterCountTotal: 583892,
    votesCountTotal: 509406,
    votesCountValid: 497820,
    votesCountInvalid: 11586,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 279328 },
      { partyId: 2, partyName: "MHP", vote: 68189 },
      { partyId: 3, partyName: "HUDAPAR", vote: 615 },
      { partyId: 4, partyName: "VATAN", vote: 916 },
      { partyId: 5, partyName: "HDP", vote: 4273 },
      { partyId: 6, partyName: "CHP", vote: 74920 },
      { partyId: 7, partyName: "SP", vote: 12591 },
      { partyId: 8, partyName: "İYİP", vote: 56701 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 207 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 80 },
    ],
    // bagimsiz_toplam_oy: 287,
    union1Vote: 6035,
    union2Vote: 1102,
    parliamentarianCount: 6,
  },
  {
    id: 62,
    name: "TUNCELİ",
    voterCountTotal: 64299,
    votesCountTotal: 55449,
    votesCountValid: 54194,
    votesCountInvalid: 1255,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 7348 },
      { partyId: 2, partyName: "MHP", vote: 3069 },
      { partyId: 3, partyName: "HUDAPAR", vote: 57 },
      { partyId: 4, partyName: "VATAN", vote: 63 },
      { partyId: 5, partyName: "HDP", vote: 28219 },
      { partyId: 6, partyName: "CHP", vote: 14406 },
      { partyId: 7, partyName: "SP", vote: 165 },
      { partyId: 8, partyName: "İYİP", vote: 852 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 15 },
    ],
    // bagimsiz_toplam_oy: 15,
    union1Vote: 170,
    union2Vote: 51,
    parliamentarianCount: 1,
  },
  {
    id: 64,
    name: "UŞAK",
    voterCountTotal: 266929,
    votesCountTotal: 242827,
    votesCountValid: 236007,
    votesCountInvalid: 6820,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 102003 },
      { partyId: 2, partyName: "MHP", vote: 25082 },
      { partyId: 3, partyName: "HUDAPAR", vote: 604 },
      { partyId: 4, partyName: "VATAN", vote: 724 },
      { partyId: 5, partyName: "HDP", vote: 6195 },
      { partyId: 6, partyName: "CHP", vote: 67428 },
      { partyId: 7, partyName: "SP", vote: 3283 },
      { partyId: 8, partyName: "İYİP", vote: 30688 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2049,
    union2Vote: 598,
    parliamentarianCount: 3,
  },
  {
    id: 65,
    name: "VAN",
    voterCountTotal: 639730,
    votesCountTotal: 529789,
    votesCountValid: 511859,
    votesCountInvalid: 17930,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 159468 },
      { partyId: 2, partyName: "MHP", vote: 14976 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4753 },
      { partyId: 4, partyName: "VATAN", vote: 808 },
      { partyId: 5, partyName: "HDP", vote: 310273 },
      { partyId: 6, partyName: "CHP", vote: 11101 },
      { partyId: 7, partyName: "SP", vote: 4088 },
      { partyId: 8, partyName: "İYİP", vote: 6078 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 127 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 187 },
    ],
    // bagimsiz_toplam_oy: 314,
    union1Vote: 2009,
    union2Vote: 298,
    parliamentarianCount: 8,
  },
  {
    id: 77,
    name: "YALOVA",
    voterCountTotal: 178253,
    votesCountTotal: 155158,
    votesCountValid: 152467,
    votesCountInvalid: 2691,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 66927 },
      { partyId: 2, partyName: "MHP", vote: 11866 },
      { partyId: 3, partyName: "HUDAPAR", vote: 286 },
      { partyId: 4, partyName: "VATAN", vote: 322 },
      { partyId: 5, partyName: "HDP", vote: 11713 },
      { partyId: 6, partyName: "CHP", vote: 44148 },
      { partyId: 7, partyName: "SP", vote: 2010 },
      { partyId: 8, partyName: "İYİP", vote: 15195 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1347,
    union2Vote: 426,
    parliamentarianCount: 3,
  },
  {
    id: 66,
    name: "YOZGAT",
    voterCountTotal: 296869,
    votesCountTotal: 256041,
    votesCountValid: 251204,
    votesCountInvalid: 4837,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 134237 },
      { partyId: 2, partyName: "MHP", vote: 63403 },
      { partyId: 3, partyName: "HUDAPAR", vote: 443 },
      { partyId: 4, partyName: "VATAN", vote: 430 },
      { partyId: 5, partyName: "HDP", vote: 2100 },
      { partyId: 6, partyName: "CHP", vote: 28757 },
      { partyId: 7, partyName: "SP", vote: 2987 },
      { partyId: 8, partyName: "İYİP", vote: 18847 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4294,
    union2Vote: 323,
    parliamentarianCount: 4,
  },
  {
    id: 67,
    name: "ZONGULDAK",
    voterCountTotal: 447085,
    votesCountTotal: 392815,
    votesCountValid: 377652,
    votesCountInvalid: 15163,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 172946 },
      { partyId: 2, partyName: "MHP", vote: 41379 },
      { partyId: 3, partyName: "HUDAPAR", vote: 815 },
      { partyId: 4, partyName: "VATAN", vote: 1522 },
      { partyId: 5, partyName: "HDP", vote: 5382 },
      { partyId: 6, partyName: "CHP", vote: 117724 },
      { partyId: 7, partyName: "SP", vote: 6778 },
      { partyId: 8, partyName: "İYİP", vote: 29915 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 1191 },
    ],
    // bagimsiz_toplam_oy: 1191,
    union1Vote: 3461,
    union2Vote: 1210,
    parliamentarianCount: 5,
  },
];
